import { render, staticRenderFns } from "./WasteWaterTreatmentComponent.vue?vue&type=template&id=76965934"
import script from "./WasteWaterTreatmentComponent.vue?vue&type=script&lang=js"
export * from "./WasteWaterTreatmentComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports